import React, {useContext, useEffect, useState} from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import {AuthContext} from "../../../config/AuthContext";
import {useNavigate, useParams} from "react-router-dom";
import NavBar from "../../components/NavBar";
import Login from "../../root/Login";
import {Button, Card, Table, Tag} from "antd";
import Historials from "../../components/Historials";
import {ColumnsType, TableProps} from "antd/es/table";
import CarregaAlgoritmix from "./components/CarregaAlgoritmix";
import {GetRebuts} from "../../../dao/multilleure/GetRebuts";
import Colors from "../../../styles/Colors";
import {BiRefresh, BiTrash} from "react-icons/bi";
import RebutAlgoritmixModel from "../../../model/multilleure/RebutAlgoritmixModel";
import {BsCurrencyDollar, BsCurrencyEuro, BsFilePdf} from "react-icons/bs";
import {PostRemesaDocument} from "../../../dao/multilleure/PostRemesaDocument";
import {DeleteAlgoritmix} from "../../../dao/multilleure/DeleteAlgoritmix";
import {PostRemesaFacturaAlgoritmix} from "../../../dao/multilleure/PostRemesaFacturaAlgoritmix";
import {PostRemesaAlgoritmisDocument} from "../../../dao/multilleure/PostRemesaAlgoritmisDocument";

const Algoritmix = () => {
    const titol: string = "Remeses Algoritmics";

    const {isLoggedIn, userId, user, page, token} = useContext(AuthContext);
    const navigate = useNavigate();
    const {id} = useParams();

    const [documentUrl, setDocumentUrl] = useState("");
    const [documentUrlPdf, setDocumentUrlPdf] = useState("");
    const [dades, setRebuts] = useState<RebutAlgoritmixModel[]>([]);
    const [loading, setLoading] = useState(false);
    const [visible, setVisible] = useState(true);


    useEffect(() => {
        handleLoadingChange(true)
        if(isLoggedIn){
            checkDades();
        }
    }, [id]);

    async function checkDades() {
        await handleLoadingChange(true);
        const dades = await GetRebuts(page);
        setRebuts(dades);
        await handleLoadingChange(false);
    }

    function toggleTable() {
        setVisible(!visible);
    }

    const handleLoadingChange = (enable: boolean) => {
        setLoading(enable);
    };

    async function deleteElement(id: 0) {
        await handleLoadingChange(true);
        await DeleteAlgoritmix(id, page);
        const dades = await GetRebuts(page);
        await setRebuts(dades);
        await handleLoadingChange(false);
    }

    async function downloadDocument(id : string) {
        const documentUrl = await PostRemesaAlgoritmisDocument(id, page, token);
        await setDocumentUrl(documentUrl);

        if (documentUrl && documentUrl !== "") {
            const link = document.createElement('a');
            link.href = documentUrl;
            link.download = `remesa${id}.xml`;
            link.target = '_blank';
            link.style.display = 'none';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    }

    async function factura(s: number) {
        const documentUrl = await PostRemesaFacturaAlgoritmix(s, page, token);
        await setDocumentUrlPdf(documentUrl);

        if (documentUrl && documentUrl !== "") {
            const link = document.createElement('a');
            link.href = documentUrl;
            link.download = `facturaRemesa${id}.pdf`;
            link.target = '_blank';
            link.style.display = 'none';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    }

    const columns: ColumnsType<RebutAlgoritmixModel> = [
        {
            key: 'id',
            title: 'ID',
            dataIndex: 'id',
            width: 15,
            sortOrder: 'descend',
            responsive: ['lg'],
            sorter: (a, b) => a.id - b.id,
        },
        {
            key: 'empresa',
            title: 'Empresa',
            dataIndex: 'empresa',
            width: 30
        },
        {
            key: 'IBAN',
            title: 'IBAN',
            dataIndex: 'IBAN',
            responsive: ['lg'],
            width: 30
        },
        {
            key: 'SEPA',
            title: 'SEPA',
            dataIndex: 'SEPA',
            responsive: ['lg'],
            width: 30
        },
        {
            key: 'total',
            title: 'Total rebut',
            dataIndex: 'total',
            width: 30,
            render: (total, ele) => (
                <Tag>{total} €</Tag>
            ),
        },
        {
            key: 'assumpte',
            title: 'Assumpte',
            dataIndex: 'assumpte',
            width: 30
        },
        {
            key: 'alta',
            title: 'Data Alta',
            dataIndex: 'alta',
            responsive: ['lg'],
            width: 30,
            render: (alta, ele) => (
                <Tag>{alta}</Tag>
            ),
        },
        {
            key: 'dataFacturacio',
            title: 'Data Facturació',
            dataIndex: 'dataFacturacio',
            width: 30,
            render: (dataFacturacio, ele) => (
                <Tag>{dataFacturacio}</Tag>
            ),
        },
        {
            key: 'accions', title: 'Accions', dataIndex: 'accions', width: 40,
            render: (estat, ele) => (
                <>
                    <Button title={"Eliminar"} style={{backgroundColor: Colors.colors.color3}}
                            onClick={() => deleteElement(ele.id)}><BiTrash/></Button>
                    {" "}
                    <Button title={"Descarregar Remesa"} onClick={() => downloadDocument(ele.id+"")}
                            style={{backgroundColor: Colors.colors.color4}}><BsFilePdf/></Button>
                    {" "}
                    <Button title={"Generar Factura"} onClick={() => factura(ele.id)}
                            style={{backgroundColor: Colors.colors.color5}}><BsCurrencyEuro/></Button>
                </>
            ),
        },
    ];

    const tableProps: TableProps<RebutAlgoritmixModel> = {
        loading
    };

    const onChange: TableProps<RebutAlgoritmixModel>['onChange'] =
        (pagination,
         filters,
         sorter,
         extra) => {
            console.log('params', pagination, filters, sorter, extra);
        };

    if (isLoggedIn) {
        return (
            <div>
                <NavBar/>
                <div className={"general"}>
                    <Card bordered={true} className={"elemento"}>
                        <Button title={"Tornar a pujar fitxer"}
                                style={{backgroundColor: Colors.colors.color4}}
                                onClick={checkDades}>
                            <BiRefresh/>
                        </Button>
                        <h4 className={"titol"} onClick={toggleTable}>{titol}</h4>
                        {visible && (
                            <Table
                                {...tableProps}
                                onChange={onChange}
                                columns={columns}
                                pagination={{pageSize: 100}}
                                scroll={{y: 400}}
                                dataSource={dades}
                            />
                        )}
                    </Card>
                    <br/>
                    <CarregaAlgoritmix checkDadesAlg={checkDades}/>
                    <br/>
                    <Historials pantalla={"ALGORITMIX"} pagina={page}/>
                </div>
            </div>
        );
    } else {
        return (
            <Login/>
        );
    }
};
export default Algoritmix;
